export default __webpack_public_path__ + "assets/images/5a1168add1c7c230273532dda4c51c46.jpg";